import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const TextInputContainer = styled.div`
  position: relative;
`;
export const TextInputLabel = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const RequiredFieldDivError = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: Lato;
  line-height: 1;
  margin: 0;
  padding: 0;
  position: relative;
  white-space: nowrap;
  font-style: italic;
}
`;
